import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'
import { Row, Col } from 'antd'
import { Editor } from 'react-draft-wysiwyg'
import draftToHtml from 'draftjs-to-html'
import { draftjsCustomToolbarConfigs } from '../shared/draftjsCustomToolbarConfigs'
import ComponentButton from '../shared/ComponentButton'
import { ErrorMessage } from 'formik'
import { convertToRaw, EditorState } from 'draft-js'
import { initEditorState } from '../utils'

interface Props {
  field: any
  form: any
}

const titleInitialTemplate = {
  button: {
    hidden: true,
    url: '',
    label: 'Continuer',
    align: 'center',
  },
}

const MainTitle = (props: Props): JSX.Element => {
  const { t } = useTranslation()
  const { field, form } = props
  const [titleState, setTitleState] = useState(
    field?.value?.content && !_.isEmpty(field.value.content)
      ? field.value.content
      : titleInitialTemplate
  )

  const [mainTitleEditor, setMainTitleEditor] = useState(
    initEditorState(field.value.title)
  )
  const [mainSubtitleEditor, setMainSubtitleEditor] = useState(
    initEditorState(field.value.subtitle)
  )

  useEffect(() => {
    form.setFieldValue(field.name, {
      ...field.value,
      content: titleState,
    })
  }, [titleState])

  return (
    <Wrapper>
      <h2>{t('ficheComparative.mainTitle.title')}</h2>
      <Row gutter={[0, 12]}>
        <Col span={24}>
          <Row gutter={[0, 2]}>
            <Col span={24}>
              <label>{t('ficheComparative.mainTitle.sectionTitle')}</label>
            </Col>
            <Col span={24}>
              <Editor
                editorState={mainTitleEditor}
                editorClassName="custom-editor"
                localization={{
                  locale: 'fr',
                }}
                onEditorStateChange={(editorState: EditorState) => {
                  setMainTitleEditor(editorState)
                }}
                toolbar={draftjsCustomToolbarConfigs().titleToolbar}
                onBlur={() =>
                  form.setFieldValue(field.name, {
                    ...field.value,
                    title: draftToHtml(
                      convertToRaw(mainTitleEditor.getCurrentContent())
                    ),
                  })
                }
              />
              <ErrorMessage
                name={`title`}
                component="div"
                className="field-error"
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[0, 2]}>
            <Col span={24}>
              <label>{t('ficheComparative.mainTitle.sectionSubtitle')}</label>
            </Col>
            <Col span={24}>
              <Editor
                defaultEditorState={mainSubtitleEditor}
                editorState={mainSubtitleEditor}
                editorClassName="custom-editor"
                localization={{
                  locale: 'fr',
                }}
                onEditorStateChange={(editorState: EditorState) => {
                  setMainSubtitleEditor(editorState)
                }}
                toolbar={draftjsCustomToolbarConfigs().subtitleToolbar}
                onBlur={() =>
                  form.setFieldValue(field.name, {
                    ...field.value,
                    subtitle: draftToHtml(
                      convertToRaw(mainSubtitleEditor.getCurrentContent())
                    ),
                  })
                }
              />
              <ErrorMessage
                name={`subtitle`}
                component="div"
                className="field-error"
              />
            </Col>
          </Row>
        </Col>
        <h3>Bouton</h3>
        <ComponentButton
          parentState={titleState}
          setParentState={setTitleState}
        />
      </Row>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
`

export default MainTitle
